import callApi from 'helpers/callApi';

export const getClassList = async (query) => {
  const params = query ? { ...query } : {};
  if (params.status === 'recommend') {
    params.status = 'all';
    params.searchBy = 'recommend';
  }
  return callApi({ url: '/classes/admin', query: { ...params } });
};

export const getAllClasses = async (query) => {
  const params = query ? { ...query } : {};
  if (params.status === 'recommend') {
    params.status = 'all';
    params.searchBy = 'recommend';
  }
  return callApi({ url: '/classes/admin', query: { ...params, limit: 1000, page: 1 } });
};

export const getClassById = (id) => callApi({ url: `/classes/${id}` }); // discuss: slug or id} ?
export const getClassStudents = (slug) => callApi({ url: `/classes/${slug}/students` });
export const getReviewClass = (id, params) => callApi({ url: `/classes/${id}/reviews`, query: params });
export const getClassLogs = (classId) => callApi({ url: `/classes/${classId}/revision` });
export const getClassOrders = (classId, query) => callApi({ url: `/classes/${classId}/orders`, query });
export const getRevenueSummariesByClassId = (classId) => callApi({ url: `/classes/${classId}/revenue-summaries` });

export const recommendClass = (id) => callApi({ url: `/classes/${id}/recommend`, method: 'post' });
export const unrecommendClass = (id) => callApi({ url: `/classes/${id}/unrecommend`, method: 'post' });

export const updateClassById = (id, data) => callApi({ url: `/classes/${id}`, body: data, method: 'put' });

export const addClassImage = (data) => callApi({ url: '/classes/images', body: data });
export const addClass = (data) => callApi({ url: '/classes', body: data });
export const closeClass = (id) => callApi({ url: `/classes/${id}/close`, method: 'post' });
export const approveClassroom = (id, data) => callApi({ url: `/classes/${id}/approve`, body: data });
export const rejectClassroom = (id, data) => callApi({ url: `/classes/${id}/reject`, body: data });

export const deleteClassById = (id) => callApi({ url: `/classes/${id}`, method: 'delete' });
export const deleteClassSchedule = (classId, scheduleId) => callApi({ url: `/classes/${classId}/schedule/${scheduleId}`, method: 'delete' });

export const editReviewById = (id, data) => callApi({ url: `/reviews/${id}`, body: data, method: 'put' });
